import naja from "naja";
import { createApp } from "vue";
import Modal from "bootstrap/js/dist/modal";
import CKEditor from '@ckeditor/ckeditor5-vue';
import DescriptionContainer from "../Description/DescriptionContainer.vue";
import { initializeArtistSelects } from "../TomSelect/selects";
import { initFlatPickr } from "../Flatpickr";
import ReportContainer from "../Report/ReportContainer.vue";
import {initLockScreen} from "../LockScreen";
import {addView} from "../View";
import {getUserIdentity} from "../helpers/User";

initLockScreen();
addView();
naja.initialize();

function initReports() {
	const reports = document.querySelectorAll('[data-vue-report]');
	reports.forEach(report => createApp(ReportContainer).mount(report));
}

let descriptionVueInstances = [];

function initMainDescription() {
	getUserIdentity().then(user => {
		createApp(DescriptionContainer).provide('user', user.data).use(CKEditor).mount(
			document.getElementById('mainDescription')
		);
	});
}

function initDescriptions() {
	descriptionVueInstances.forEach(descriptionVueInstance => {
		if (descriptionVueInstance.app) {
			descriptionVueInstance.app.unmount();
		}
	});

	let descriptions = document.querySelectorAll('[data-vue-description-id]:not(#mainDescription)');

	getUserIdentity().then(user => {
		descriptions.forEach(description => {
			const app = createApp(DescriptionContainer).provide('user', user.data).use(CKEditor);
			let instance = app.mount(description);
			let instanceObject = {};
			instanceObject['app'] = app;
			instanceObject['instance'] = instance;

			descriptionVueInstances.push(instanceObject);
		});
	});

}


let modals = [];
function initModals() {
	const modalElements = document.querySelectorAll('.modal');

	modalElements.forEach(modal => {
		const modalInstance = Modal.getInstance(modal);

		if (modalInstance) {
			modalInstance.hide();
			modalInstance.dispose();
		}

		modals.push(
			new Modal(modal, {
				keyboard: false,
				focus: false,
			})
		);
	});
}

initializeArtistSelects();
initFlatPickr();
initDescriptions();
initReports();
initMainDescription();

naja.addEventListener('before', (event) => {
	const activeModalElement = document.querySelector('.modal.show');
	const activeModal = Modal.getInstance(activeModalElement);

	if (activeModal) {
		activeModal.hide();
	}
});

naja.addEventListener('success', (event) => {
	initModals();
	initDescriptions();
	initReports();
	initializeArtistSelects();
	initFlatPickr();
});

const addCoverButton = document.getElementById('addCover');

if (addCoverButton) {
	addCoverButton.addEventListener('click', () => {
		const coverInputHider = document.querySelector('.covers input');

		if (coverInputHider) {
			coverInputHider.dispatchEvent(new Event('click'));
		}
	});
}
